/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Ats_ReadabilityInputs */

const en_onboarding_ats_readability = /** @type {(inputs: Onboarding_Ats_ReadabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Readability`)
};

const de_onboarding_ats_readability = /** @type {(inputs: Onboarding_Ats_ReadabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lesbarkeit`)
};

const fr_onboarding_ats_readability = /** @type {(inputs: Onboarding_Ats_ReadabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lisibilité`)
};

const es_onboarding_ats_readability = /** @type {(inputs: Onboarding_Ats_ReadabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legibilidad`)
};

const it_onboarding_ats_readability = /** @type {(inputs: Onboarding_Ats_ReadabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leggibilità`)
};

const nl_onboarding_ats_readability = /** @type {(inputs: Onboarding_Ats_ReadabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leesbaarheid`)
};

const pl_onboarding_ats_readability = /** @type {(inputs: Onboarding_Ats_ReadabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czytelność`)
};

const fi_onboarding_ats_readability = /** @type {(inputs: Onboarding_Ats_ReadabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luettavuus`)
};

const da_onboarding_ats_readability = /** @type {(inputs: Onboarding_Ats_ReadabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Læsbarhed`)
};

const sv_onboarding_ats_readability = /** @type {(inputs: Onboarding_Ats_ReadabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Läsbarhet`)
};

/**
* | output |
* | --- |
* | "Readability" |
*
* @param {Onboarding_Ats_ReadabilityInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const onboarding_ats_readability = /** @type {((inputs?: Onboarding_Ats_ReadabilityInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Ats_ReadabilityInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_onboarding_ats_readability(inputs)
	if (locale === "fr") return fr_onboarding_ats_readability(inputs)
	if (locale === "es") return es_onboarding_ats_readability(inputs)
	if (locale === "it") return it_onboarding_ats_readability(inputs)
	if (locale === "nl") return nl_onboarding_ats_readability(inputs)
	if (locale === "pl") return pl_onboarding_ats_readability(inputs)
	if (locale === "fi") return fi_onboarding_ats_readability(inputs)
	if (locale === "da") return da_onboarding_ats_readability(inputs)
	if (locale === "sv") return sv_onboarding_ats_readability(inputs)
	return en_onboarding_ats_readability(inputs)
});